import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=634c0f30&"
import script from "./ContextMenu.vue?vue&type=script&lang=js&"
export * from "./ContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=634c0f30&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634c0f30')) {
      api.createRecord('634c0f30', component.options)
    } else {
      api.reload('634c0f30', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=634c0f30&", function () {
      api.rerender('634c0f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Translation/ContextMenu.vue"
export default component.exports